var _circle, _circle2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProductActivation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 23,
    stroke: "#322F61",
    strokeWidth: 2,
    strokeDasharray: "2 2"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 20,
    fill: "#322F61"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_68_42332)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.8333 16.5H18.1667C17.2417 16.5 16.5 17.25 16.5 18.1667V29.8333C16.5 30.75 17.2417 31.5 18.1667 31.5H29.8333C30.75 31.5 31.5 30.75 31.5 29.8333V18.1667C31.5 17.25 30.7583 16.5 29.8333 16.5ZM29.8333 29.8333H18.1667V19.8333H29.8333V29.8333ZM28.1667 24H19.8333V22.3333H28.1667V24ZM24.8333 27.3333H19.8333V25.6667H24.8333V27.3333Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_68_42332"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(14 14)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductActivation);
export default __webpack_public_path__ + "static/media/product-activation.0981775a7972687f3d30d84bc4514064.svg";
export { ForwardRef as ReactComponent };